import { render, staticRenderFns } from "./business-details.vue?vue&type=template&id=03182d4c&scoped=true&"
import script from "./business-details.vue?vue&type=script&lang=js&"
export * from "./business-details.vue?vue&type=script&lang=js&"
import style0 from "./business-details.vue?vue&type=style&index=0&id=03182d4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03182d4c",
  null
  
)

export default component.exports